module.exports = __webpack_public_path__ + "img/9.c4d3eda9.jpg";